import Vue from 'vue';

Vue.component('user-index', () =>
    import(/* webpackChunkName: 'user' */ './user-index.vue'),
);

Vue.component('user_station_list', () =>
    import(/* webpackChunkName: 'user' */ './station_list.vue'),
);
